import React from 'react';
import { Link } from 'gatsby';
import Img from 'gatsby-image';

import styles from './styles.module.scss';

const DEFAULT_BUTTON_TEXT = 'Find out more';

const SeasonThingsToDo = ({
    title,
    description,
    image,
    buttonText = DEFAULT_BUTTON_TEXT,
    buttonLink,
}) => {
    if (!title && !description && !image) {
        return null;
    }

    return (
        <section className={styles.thingsToDo}>
            <div className={styles.frame}>
                <div className={styles.split}>
                    <div className={styles.content}>
                        {!!title && <h2 className={styles.title}>{title}</h2>}
                        {!!description &&
                            description
                                .split(/\n\s*\n/)
                                .filter(Boolean)
                                .map((paragraph, index) => (
                                    <p className={styles.description} key={index}>
                                        {paragraph.trim()}
                                    </p>
                                ))}
                        {!!buttonLink && (
                            <Link to={buttonLink} className={styles.link}>
                                {buttonText}
                            </Link>
                        )}
                    </div>
                    {image?.childImageSharp?.fluid && (
                        <div className={styles.image}>
                            <Img fluid={image.childImageSharp.fluid} alt={title} />
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default SeasonThingsToDo;
